import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Symbols } from "../GameComponents/Symbols";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { BaseView } from "../GameComponents/Base/BaseView";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { GameManager } from "../Managers/GameManager";
import { PlayList } from "../Components/Sounds/PlayList";
import { ModuleManager } from "../Managers/ModuleManager";
import { Payline } from "../GameComponents/Payline";
import { Symbol } from "../GameComponents/Symbol";
import { PaylinesExtended } from "./PaylinesExtended";
import { Settings } from "./Settings";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { ReelExtended } from "./ReelExtended";
import { BetManager } from "../Managers/BetManager";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtended extends WinAnimator {
    private _linesRetractable: SwitchElement;
    private _lineTable1: SwitchElement;
    private _lineTable2: SwitchElement;

    public static Force: boolean = false;

    public isFS: boolean = false;

    public selectorFinished() {
        this.currentAnimationFinished = true;
        this.currentAnimationIndex = null;
        this.finishFirstWins();
        this.emit(WinAnimator.FinishWinCalculation);
    }

    initialize(
        symbols: Symbols,
        paylines?: PaylinesExtended,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        parent?: BaseView | FreespinsView,
    ): void {
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);

        if (parent) {
            if (parent.childs["LineTable1"]) {
                this._lineTable1 = parent.childs["LineTable1"];
            }
            if (parent.childs["LineTable2"]) {
                this._lineTable2 = parent.childs["LineTable2"];
            }
            if (parent.childs["LinesRetractable"]) {
                this._linesRetractable = parent.childs["LinesRetractable"];
            }
        }
    }

    public showInitWins(wins: Array<Communication.Game.IWin>, win: number): void {
        this.currentWins = wins;
        this.currentWin = win;

        this.resetAnimations();

        let scatter = this.currentWins.filter((w) => w.trigger === Communication.Game.WinTrigger.Scatter).length;
        let custom = this.currentWins.filter((w) => w.trigger === Communication.Game.WinTrigger.Custom).length;

        if (scatter) {
            // nop
        } else if (custom === this.currentWins.length) {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
        } else if (wins != null && wins.length > 0) {
            this.showCustomInitWin();
            this.showFirstInitWins();
            this.finishFirstInitWins();
        } else {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
        }
    }

    public cycleWins(isFirst: boolean = false) {
        if (
            this.currentWins == null ||
            this.currentWins.filter((w) => w.type === Communication.Game.WinType.freeSpins).length ===
                this.currentWins.length
        ) {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            return;
        }
        let filtered = this.currentWins.filter((w) => w.type !== Communication.Game.WinType.freeSpins).length;

        if (this._linesRetractable) {
            this._linesRetractable.goToCase("HIDE");
        }
        if (this.currentWins && this.currentWins[this.currentCycle]) {
            const win = this.currentWins[this.currentCycle];
            if (win.paylineId) {
                if (this._lineTable1) {
                    this._lineTable1.goToCase("LINE_" + win.paylineId);
                    if (filtered === 1) {
                        this._lineTable1.goToCase("LINE_POP_SINGLE");
                    } else {
                        this._lineTable1.goToCase("LINE_POP");
                    }
                }
                if (this._lineTable2) {
                    this._lineTable2.goToCase("LINE_" + win.paylineId);
                    if (filtered === 1) {
                        this._lineTable2.goToCase("LINE_POP_SINGLE");
                    } else {
                        this._lineTable2.goToCase("LINE_POP");
                    }
                }
            }
        }

        if (isFirst) {
            this.cycleStep = 0;
        } else {
            this.cycleStep++;
        }

        PlayList.play("SND_BaseWinline");
        PlayList.play("SND_BaseRecapLoopSymbol");

        if (
            !this.isFS &&
            !ModuleManager.freespinsEnabled() &&
            !ModuleManager.freespinsActive() &&
            this.cycleStep % 4 === 0
        ) {
            this.cycleStep = 0;
            PlayList.setVolume("SND_BaseLoop", 0);
            PlayList.setVolume("SND_FSLoop", 0);
            PlayList.loop("SND_BaseRecapLoop", 10);
        }

        if (
            this.currentWins[this.currentCycle] &&
            this.currentWins[this.currentCycle].type !== Communication.Game.WinType.freeSpins
        ) {
            this.allPaylinesGoToCase(Payline.CaseNowin);
            this.allSymbolsGoToCase(Symbol.CaseNowin, true);

            this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseCycle, true);
            this.winPaylineGoToCase(this.currentCycle, Payline.CaseCycle);

            this.sortSymbols(true);

            this.currentCycle = this.currentCycle >= this.currentWins.length ? 0 : this.currentCycle + 1;
            this.startTimer(WinAnimator.CycleWins, this.getCycleWinsDelayWithCorrection(isFirst));
        } else {
            //this.currentCycle++;
            this.currentCycle = this.currentCycle >= this.currentWins.length ? 0 : this.currentCycle + 1;
            this.startTimer(WinAnimator.CycleWins, 0);
        }
    }

    /*
    protected winSymbolsGoToCaseAsCustom(winIndex: number, caseType: string): Array<Symbol> {
        let ret: Symbol[] = [];
        this.currentSymbols.forEach(reel => {
            reel.forEach(symbol => {
                if(symbol.id === Settings.SymbolBonus -1) {
                    ret.push(symbol);
                    symbol.goToCase(caseType);
                }
            });
        });
        return ret;
    }
    */

    protected startAnimation() {
        super.startAnimation();
        if (!this.currentWin) {
            const animation = this.animations[this.currentAnimationIndex];
            animation.stop();
            animation.visible = false;
            this.currentAnimationIndex = null;
            this.finishFirstWins();
        }
    }

    reset(showLastSymbols: boolean, spin: boolean = false): boolean {
        if (this._linesRetractable) {
            this._linesRetractable.goToCase("SHOW");
        }
        if (this._lineTable1) {
            this._lineTable1.goToCase("RESET");
        }
        if (this._lineTable2) {
            this._lineTable2.goToCase("RESET");
        }
        return super.reset(showLastSymbols, spin);
    }

    interruptAnimations() {
        this.currentCycle = 0;
        if (this.currentAnimationFinished) {
            this.resetAnimations();
        } else {
            this.stopAnimation();
            this.currentAnimationFinished = true;
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    /**
     * Sorts symbols according to their zIndex attribute, if applicable
     */
    public sortSymbols(winOnly: boolean = false): void {
        if (!this.symbols.hasZindex) {
            return;
        }
        let addQueue: Symbol[] = [];
        this.symbolsContainer.children.forEach((symbol) => {
            addQueue.push(<Symbol>symbol);
        });
        addQueue.sort((a, b) => a.zIndex - b.zIndex);
        addQueue.forEach((symbol) => {
            this.symbolsContainer.addChild(symbol);
        });
        if (!winOnly) {
            addQueue = [];
            this.noWinSymbolsContainer.children.forEach((symbol) => {
                addQueue.push(<Symbol>symbol);
            });
            addQueue.sort((a, b) => a.zIndex - b.zIndex);
            addQueue.forEach((symbol) => {
                this.noWinSymbolsContainer.addChild(symbol);
            });
        }
    }

    protected showFirstWins() {
        super.showFirstWins();
        this.sortSymbols();
    }

    protected showFirstInitWins() {
        super.showFirstInitWins();
        this.sortSymbols();
    }

    showSymbols(reelsData: Array<Communication.Game.IReel>) {
        super.showSymbols(reelsData);
        if (ModuleManager.freespinsActive()) {
            this.currentSymbols.forEach((reel) =>
                reel.forEach((symbol) => {
                    if (symbol.id === Settings.SymbolWild - 1) {
                        const bg = symbol.getChildElementByName("Body");
                        const fg = symbol.getChildElementByName("Text");
                        if (bg && bg instanceof ContainerElement && fg && fg instanceof ContainerElement) {
                            const mul = fg.getChildElementByName("Multiplier");
                            const zero = bg.getChildElementByName("Zero");
                            if (mul && mul instanceof ImageTextElement && zero && zero instanceof ImageElement) {
                                if (this.isFS) {
                                    if (zero && zero instanceof ImageElement) {
                                        zero.visible = false;
                                    }
                                    mul.setText("x" + FreespinsView.Multiplier.toString());
                                } else {
                                    if (zero && zero instanceof ImageElement) {
                                        zero.visible = true;
                                    }
                                    mul.setText("");
                                }
                            }
                        }
                    }
                }),
            );
        }

        this.sortSymbols();
    }

    onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number) {
        super.onReelStopped(reelsData, reelIndex);
        this.sortSymbols();
        let precedingBonuses = reelsData.filter(
            (reel, rI) => rI < reelIndex && reel.symbols.filter((symbol) => symbol === Settings.SymbolBonus).length > 0,
        ).length;
        let canImpact = this.reelCount - reelIndex + precedingBonuses >= 3;
        let sound = false;
        this.currentSymbols.forEach((reel, rIndex) => {
            reel.forEach((symbol) => {
                if (symbol) {
                    if (rIndex < reelIndex && reelIndex == this.reelCount - 1) {
                        symbol.goToCase("NORMAL");
                    } else if (reelIndex === rIndex) {
                        if (canImpact && symbol.hasCase("IMPACT")) {
                            if (!sound) {
                                PlayList.play("SND_BaseBonusHit" + reelIndex);
                                sound = true;
                            }
                            symbol.goToCase("IMPACT");
                        } else if (ReelExtended.Tease) {
                            symbol.goToCase("NOWIN");
                        }
                    } else if (!symbol.hasCase("IMPACT") && ReelExtended.Tease) {
                        symbol.goToCase("NOWIN");
                    }
                }
            });
        });
        if (reelIndex === this.reelCount - 1 && !this.isFS && ModuleManager.freespinsEnabled()) {
            //PlayList.play("SND_BaseFSTeaserWin");
        } else if (!sound) {
            PlayList.play("SND_BaseRotationEnd" + reelIndex);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtended.ts
 **/